<template>
  <v-row justify="center">
    <v-dialog v-bind:value="showDialog" scrollable transition="dialog-bottom-transition" @input="v => v || hideViewer()"
      @keydown.esc="hideViewer({ dropReceipt: true })" min-width="600px">
      <!-- <template v-slot:activator="{ on }"></template> -->
      <v-card>
        <v-card-title v-if="userRoles != 'AGENT'">
          <v-chip :color="getColor(status)">{{ status }}</v-chip>
          <span style="margin-left: 1.5rem">Reference: #{{ referenceNumber }}</span>
          <v-chip v-if="reClaimed === 1" style="margin-left: 0.5rem" color="red">Re-Evaluate</v-chip>
          <span v-if="reClaimed === 1" style="margin-left: 0.5rem; font-size:0.8rem" color="red">{{ reClaimText }}</span>
          <span style="margin-left: 2.5rem">Campaign: {{ getCampaign() }}</span>
          <span v-if="isAlwaysCampaign" style="margin-left: 2.5rem">{{ alwaysCampaignText() }}</span>
          <div v-if="showFraudRiskScore()">
            <v-chip class="ml-3" :color="getColorForFraudRist(fraudRiskScore)">Fraud Score: {{ fraudRiskScore }}</v-chip>
          </div>

          <div v-if="showFraudModelScore()">
            <v-chip class="ml-3" :color="getColorForFraudModelScore(fraudModelScore)">Fraud Model Score: {{ fraudModelScore }}</v-chip>
          </div>
          <div v-if="showFraudAction()">
            <v-chip class="ml-3" :color="getColorIfFraud(fraudResult)" :style="{ color: getColorIfFraud(fraudResult) === '#4a171b' || getColorIfFraud(fraudResult) === '#000000' ? 'white' : '' }">Fraud Result: {{ showFraudAction() }}</v-chip>
          </div>
          
          <div v-if="hasCouponId">
            <v-chip class="ml-3" color="primary">Coupon ID: {{ couponId }}</v-chip>
          </div>
        </v-card-title>
        <v-card-title v-else>

          <span>Campaign: {{ getCampaign() }}</span>
          <span style="margin-left: 1.5rem">Reference: #{{ referenceNumber }}</span>
          <v-chip style="margin-left: 2.5rem" :color="getColor(status)">{{ status }}</v-chip>
          <span v-if="isAlwaysCampaign" style="margin-left: 1.5rem">{{ alwaysCampaignText() }}</span>

          <v-chip v-if="reClaimed === 1" style="margin-left: 0.5rem" color="red">Re-Evaluate</v-chip>
          <span v-if="reClaimed === 1" style="margin-left: 0.5rem; font-size:0.8rem" color="red">{{ reClaimText }}</span>

          <span v-if="(status === 'Rejected' || status === 'Confirmed') && rejectReason !== 'used'"
            style="margin-left: .5rem">
            <v-chip error color="warning">{{ rejectReason }}</v-chip>
          </span>
          <span v-if="paymentStatus" style="margin-left: .5rem; cursor: pointer;" @click="copyToClipboard(paymentDate)">
            <v-tooltip bottom color="primary">
              <template v-slot:activator="{ on, attrs }">
                <v-chip error color="primary" v-bind="attrs" v-on="on">{{ paymentStatus }}
                </v-chip>
              </template>
              <span v-if="paymentDate">Payment Date: {{ paymentDate }}</span>
            </v-tooltip>
          </span>
          <v-menu v-else open-on-hover transition="slide-x-transition" bottom offset-y>

            <template #activator="{ attrs, on }">
              <span v-bind="attrs" v-on="on" style="margin-left: .5rem;
                      border-radius: 40px;
                      padding: 0px 10px 0px 10px;
                      cursor: pointer;" :style="(sendSftp === 1) ? 'backgroundColor: blue' : 'backgroundColor: grey'">
                {{ (sendSftp === 1) ? 'Stfp Sent' : 'Stfp Unsent' }}
              </span>
              <span v-bind="attrs" v-on="on" style="margin-left: .5rem;
                      border-radius: 40px;
                      padding: 0px 10px 0px 10px;
                      cursor: pointer;" :style="used ? 'backgroundColor: red' : 'backgroundColor: grey'">
                {{ used ? 'USED' : 'UN-USED' }}
              </span>
            </template>
            <v-alert v-if="used" dense type="info" min-width="250px" max-width="300px" class="mx-0 mb-0">
              {{ dupRefNum }}
            </v-alert>
          </v-menu>
          <span v-if="sftpFile">
            {{ sftpFile }}
          </span>
          <div v-if="showFraudRiskScore()">
            <v-chip class="ml-3" :color="getColorForFraudRist(fraudRiskScore)">Fraud Score: {{ fraudRiskScore }}</v-chip>
          </div>
          <div class="ml-auto d-flex flex-column justify-content-end.">
            <v-btn v-if="selectedDashboard.hasAdditionalPayment && userRoles === 'AGENT'"
              @click="_createAdditionalPayment" color="primary" small>
              Create Additional Payment
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-flex md5 class="mt-4">
              <div v-if="!selectedDashboard.isCroppable" class="btn-wrapper">
                <v-btn @click="selectedIndex = 0" :class="{ selected: selectedIndex == 0 }">
                  Receipt
                </v-btn>
                <v-btn v-for="(product, idx) in productImageURL" :key="`product[${idx}]`" :disabled="!productImageURL"
                  @click="setProduct(product, idx + 1)" :class="{ selected: selectedIndex === idx + 1 }">
                  Product {{ idx + 1 }}
                  <span v-if="!productImageURL">(No photos)</span>
                </v-btn>
              </div>
              <div id="image-container" class="image-container">
                <template v-if="selectedIndex == 0 && receiptImageSrc != ''">
                  <div v-viewer="{ inline: true, button: false, navbar: false, title: false, tooltip: false, fullscreen: false }">
                    <img :src="receiptImageSrc" id="receipt-img" @load="onImageLoaded" alt="Receipt Image" />
                  </div>
                </template>
                <template v-else-if="selectedIndex > 0">
                  <div v-viewer="{ inline: true, button: false, navbar: false, title: false, tooltip: false, fullscreen: false }">

                    <img :src="`${productImageSrc}`" alt="Product Image" />
                  </div>
                </template>
                <template v-else>
                  <img src="@/assets/loading.gif" alt="Loading">
                </template>
              </div>
            </v-flex>
            <v-flex md7 class="right-content">
              <v-tabs fixed-tabs v-model="activeTab">
              </v-tabs>
              <v-tabs-items v-model="activeTab">
                <v-tab-item>
                  <TabReceiptDetails :fraudModelWeights="fraudModelWeights" :showDialog="showDialog" :inspectMode="inspectMode" v-on:hideviewer="hideViewer()"
                    ref="receiptDetails" />
                </v-tab-item>
              </v-tabs-items>
            </v-flex>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="yellow darken-1" @click="hideViewer({ dropReceipt: true, cancelBtn: true })">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { mapFields } from "@/store/helpers";
import TabReceiptDetails from "./ReceiptViewer/TabReceiptDetails.vue";
import moment from "moment";
import axios from "axios";

export default {
  components: {
    TabReceiptDetails
  },
  data() {
    return {
      activeTab: 0,
      viewedList: [],
      selectedIndex: 0,
      receiptImageSrc: '',
      productImageSrc: '',
      couponId: ''
    };
  },
  props: {
    receiptImage: {
      required: true
    },
    showDialog: {
      required: true,
      type: Boolean
    },
    inspectMode: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapFields([
      "reClaimText",
      "reClaimed",
      "coinImageURL",
      "status",
      "referenceNumber",
      "receiptImageURL",
      "id",
      "campaign_fk",
      "rejectReason",
      "createdAt",
      "used",
      "dupRefNum",
      "sendSftp",
      "sftpFile",
      "paymentHistory",
      "paymentStatus",
      "extra",
      "fraudResult"
    ]),
    ...mapGetters(["userToken", "selectedDashboard", "userRoles", "productImageURL", "autoPilotMode", "fraudRiskScore","fraudModelScore","fraudModelWeights", "fraudResult"]),
    imgBtnColor() {
      return this.$vuetify.theme.isDark ? {
        selected: 'grey darken-4',
        unselected: 'grey darken-3'
      } : {
        selected: 'grey lighten-1',
        unselected: 'grey lighten-3'
      };
    },
    isAlwaysCampaign() {
      return this.campaign_fk === "always-testwoche";
    },
    paymentDate() {
      return moment(this.paymentHistory.updated_at).format("DD/MM/YYYY")
    },
    hasCouponId() {
      if (this.extra && this.extra.coupon_type_id) {
        this.couponId = this.extra.coupon_type_id;
        return true
      }
      return false
    }
  },
  mounted() {
    if (this.receiptImage.src === "") {
      this.receiptImage.src = this.receiptImageURL
    }

    if (this.receiptImageURL)
      this.fetchImage();

    if (typeof this.productImageURL === "string" && this.productImageURL.startsWith("[")) {
      this.$store.state.currentReceipt.productImageURL = JSON.parse(this.productImageURL);
    }
  },
  methods: {
    ...mapActions(["dropReceipt", "snackAlert", "createAdditionalPayment"]),
    ...mapMutations(["setReceiptImageFile"]),
    fetchImage() {
      const param = '?v=' + Math.round(Math.random() * 10000)
      axios({
        method: 'get',
        url: this.receiptImageURL.includes('?') ? this.receiptImageURL : this.receiptImageURL + param,
        responseType: 'blob',
      })
        .then(response => {
          const contentType = response.headers['content-type'] || 'image/jpeg';
          const fileExtension = contentType === 'image/png' ? 'png' : 'jpg';
          const file = new File([response.data], `receipt.${fileExtension}`, { type: contentType });

          this.receiptImageSrc = URL.createObjectURL(file);
          this.setReceiptImageFile(file);
        })
        .catch(error => {
          this.snackAlert({
            message: "Receipt image could not be loaded, trying again in 2 secs...",
            type: "warning"
          });
          return this.errorImage();
        });
    },
    errorImage() {
      setTimeout(() => {
        this.fetchImage();
      }, 2000);
    },
    onImageLoaded() {
      this.selectedIndex = 0
    },
    getColor(status) {
      if (status === "Confirmed") return "success";
      else if (status === "Rejected") return "error";
      else if (status === "Pre-Confirmed") return "blue-grey";
      else return "blue-grey";
    },
    hideViewer(options = { dropReceipt: false, cancelBtn: false }) {
      const { dropReceipt, cancelBtn } = options;
      const canBeDroppable = dropReceipt && this.status == "Pre-Confirmed";
      
        // Clean up image container with a delay to avoid removeChild error
      setTimeout(() => {
        const imageContainer = document.getElementById('image-container');
        if (imageContainer && imageContainer.parentNode) {
          imageContainer.parentNode.removeChild(imageContainer);
        }
      }, 100);
      
      //clean dropdown list
      if (this.userRoles === "OPERATOR") {
        this.$refs.receiptDetails.$refs.productsDropDown.clean();
      }

      if (cancelBtn) {
        this.$emit("closeAutoPilot", true);
      }

      if (canBeDroppable) {
        this.dropReceipt({
          userToken: this.userToken,
          dashboard: this.selectedDashboard,
          receiptToken: this.id
        });
        this.$emit("closeAutoPilot", true);
      }
      this.viewedList = [];
      this.$store.commit("setViewedProduct", []);
      this.$store.commit("setReuploadLink", "");
      this.$store.commit("setPayoutLink", "");
      this.$store.commit("clearCurrentReceipt");
      this.$store.commit("setFraudRiskScore", "");
      this.$store.commit("setFraudModelScore", "");
      this.$store.commit("setFraudResult", "");
      this.$store.commit("setFraudModelWeights", "");
      this.$store.state.currentCountry = '';
      this.selectedDashboard.needsCrop = true;
      this.$emit("hide", !cancelBtn);
      this.$refs.receiptDetails.editMode = false;
      if (!this.autoPilotMode) {
        this.$emit("closeAutoPilot", true);
      }
    },
    getCampaign() {
      if (this.campaign_fk == "al-testwoche") return "Ariel Lenor Testwochen";
      if (this.campaign_fk == "always-testwoche") return "AlwaysTestwochen";
      if (this.campaign_fk == "pampers-spar") return "Pampers Spar";
      if (this.campaign_fk == "ariel-4.0-rabatt") return "Ariel Rabatt";
      if (this.campaign_fk == "pampers-2.0-spar") return "Pampers DM";
      if (this.campaign_fk == "pampers-3.0-aldi") return "Pampers Sparvorteil Aldi Nord&Süd";
      const campaignName = this.campaign_fk || this.selectedDashboard.campaignId
      return campaignName;
    },
    async setProduct(img, idx) {
      if (this.selectedIndex != idx) await this.setProductImageSrc(idx) // prevent unnecessary request
      this.selectedIndex = idx
      if (this.viewedList.indexOf(img) === -1) {
        this.$store.commit("setViewedProduct", []);
        this.viewedList.push(img)
      }
      this.$store.commit("setViewedProduct", this.viewedList);
    },
    alwaysCampaignText() {
      return moment(this.createdAt).isBefore("2020-12-01") ? 'OLD CAMPAIGN' : "NEW CAMPAIGN"
    },
    copyToClipboard(status) {
      navigator.clipboard.writeText(status)
      return this.snackAlert({
        message: "Copied to clipboard",
        type: "success"
      });
    },
    getColorForFraudRist(value) {
      const score = parseFloat(value)
      if (score >= 0 && score <= 0.3) return "green"
      if (score > 0.3 && score <= 0.6) return "yellow"
      if (score > 0.6 && score <= 0.75) return "orange"
      if (score > 0.75) return "red"
      else return "grey"
    },
    showFraudRiskScore() {
      const score = parseFloat(this.fraudRiskScore)
      return score >= 0 ? true : false
    },

    getColorForFraudModelScore(value) {
      const score = parseFloat(value)
      if (score >= 0 && score < 0.5) return "green"
      if (score >= 0.5 && score < 0.7) return "yellow"
      if (score >= 0.7) return "red"
    },
    showFraudModelScore() {
      const score = parseFloat(this.fraudModelScore)
      return score >= 0 ? true : false
    },

    showFraudAction() {
      return this.fraudResult === "POSITIVE" ? "FRAUD" : this.fraudResult === "POSITIVE_BLACKLIST" ? "FRAUD + BLACKLISTED" : this.fraudResult === "NEGATIVE" ? "NOT FRAUD" : false;
    },

    getColorIfFraud(value) {
      if (value === "POSITIVE_BLACKLIST") return "#000000"
      if (value === "POSITIVE") return "#4a171b"
      if (value === "NEGATIVE") return "#A7C1A8"
    },

    async setProductImageSrc(selectedIndex) {
      await axios({
        method: 'get',
        url: this.productImageURL[selectedIndex - 1],
        responseType: 'blob',
      })
        .then(response => {
          this.productImageSrc = URL.createObjectURL(response.data);
        })
        .catch(error => {
          this.snackAlert({
            message: "Product image could not be loaded, trying again in 2 secs...",
            type: "warning"
          });
        });
    },
    _createAdditionalPayment () {
      this.createAdditionalPayment({ dashboard: this.selectedDashboard, receiptToken: this.id, campaignId: this.campaign_fk })
        .then((res) => {
          this.snackAlert({
            message: `Additional Payment Created with Reference Number: ${res.newReferenceNumber}`,
            type: "success"
          });
        })
        .catch((err) => {
          this.snackAlert({
            message: err.error.message,
            type: "error"
          });
        })
    }
  },
  watch: {
    selectedIndex: {
      handler() {
        // Clean up viewer containers with a delay when switching to avoid removeChild error
        setTimeout(() => {
          const vViewers = document.getElementsByClassName('viewer-container')
          if (vViewers.length > 1) {
            for (let i=1; i<vViewers.length; i++) {
              // i starts from 1 instead of 0 to keep the first element in dom
              if (vViewers[i] && vViewers[i].parentNode) {
                vViewers[i].parentNode.removeChild(vViewers[i])
              }
            }
          }
        }, 100);
      },
      immediate: true
    }
  }
};
</script>
<style lang="scss">
.btn-wrapper {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  position: relative;
  z-index: 10;

  button {
    width: 50%;
    border-radius: 0;

    &.selected {
      background-color: #53B1FD !important;
    }
  }
}

.image-container {
  max-width: 100%;
  overflow: hidden;

  img {
    width: 100%;
  }
}
</style>
